import {
  APP_BOOTSTRAP_LISTENER,
  makeEnvironmentProviders,
} from '@angular/core';
import { GtagLoaderService } from '@core/services/tracking/gtag-loader.service';

export function provideGtagInitializer() {
  return makeEnvironmentProviders([
    {
      provide: APP_BOOTSTRAP_LISTENER,
      multi: true,
      useFactory: (loader: GtagLoaderService) => {
        return async () => {
          await loader.load();
        };
      },
      deps: [GtagLoaderService],
    },
  ]);
}
